import {useState} from 'react';
import axios from 'axios';
import { Media, ResolutionObject } from '../dtos/guest';
import { FAKE_API, fakeUploadedMedia } from '../fake';
const LIBRARY_ID = '448826';
const API_KEY = '9c08bbde-b651-4e93-838655accf8c-8aae-4b62';
const CDN_URL = 'https://vz-4a7e62cf-751.b-cdn.net';

const axiosInst = axios.create();
export enum UploadStatus {
  PREPARING = 'preparing',
  UPLOADING = 'uploading',
  PROCESSING = 'processing',
  FETCHING_METADATA = 'fetching metadata',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

// interface UploadProgress {
//   loaded: number;
//   total: number;
// }

// interface UploadOptions {
//   method?: string;
//   headers?: Record<string, string>;
//   onProgress?: (progress: UploadProgress) => void;
// }

// interface UploadResponse {
//   status: number;
//   body: string;
//   headers: Record<string, string>;
// }


// const uploadFileWithProgress = (
//   url: string,
//   file: File,
//   options: UploadOptions = {}
// ): Promise<UploadResponse> => {
//   return new Promise((resolve, reject) => {
//     const xhr = new XMLHttpRequest();
//     const method = options.method || 'PUT';

//     // Set up progress tracking
//     if (options.onProgress) {
//       xhr.upload.addEventListener('progress', (event) => {
//         if (event.lengthComputable && options.onProgress) {
//           options.onProgress({
//             loaded: event.loaded,
//             total: event.total,
//           });
//         }
//       });
//     }

//     // Handle response
//     xhr.onload = () => {
//       const headers: Record<string, string> = {};
//       const headerString = xhr.getAllResponseHeaders();
//       if (headerString) {
//         headerString.split('\r\n').forEach((line) => {
//           const parts = line.split(': ');
//           if (parts.length === 2) {
//             headers[parts[0].toLowerCase()] = parts[1];
//           }
//         });
//       }

//       resolve({
//         status: xhr.status,
//         body: xhr.responseText,
//         headers,
//       });
//     };

//     xhr.onerror = () => {
//       reject(new Error('Network error during upload'));
//     };

//     xhr.ontimeout = () => {
//       reject(new Error('Upload timeout'));
//     };

//     // Open request
//     xhr.open(method, url, true);

//     // Set headers
//     if (options.headers) {
//       Object.entries(options.headers).forEach(([key, value]) => {
//         xhr.setRequestHeader(key, value as any);
//       });
//     }

//     // Read file using react-native-fs and convert to ArrayBuffer for upload
//     // Handle both file:// URIs and plain paths
//     // const filePath = fileUri.startsWith('file://') 
//     //   ? fileUri.replace('file://', '') 
//     //   : fileUri;
    
//     convertToBase64(file)
//       .then((base64Data: any) => {
//         const base64Clean = base64Data.split(',')[1] || base64Data;
//         // Convert base64 to binary string, then to ArrayBuffer
//         const binaryString = atob(base64Clean);
//         console.log('binaryString', binaryString)
        
//         const bytes = new Uint8Array(binaryString.length);
//         for (let i = 0; i < binaryString.length; i++) {
//           bytes[i] = binaryString.charCodeAt(i);
//         }
//         xhr.send(bytes.buffer);
//       })
//       .catch((error: any) => {
//         reject(new Error(`Failed to read file: ${error?.message || String(error)}`));
//       });
//   });
// };

// function convertToBase64(file: File) {
//     return new Promise((resolve, reject) => {
//         const reader = new FileReader();
//         reader.readAsDataURL(file); // Reads file and encodes as Base64
//         reader.onload = () => resolve(reader.result);
//         reader.onerror = error => reject(error);
//     });
// }

export const useVideoUploader = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [status, setStatus] = useState<UploadStatus>(UploadStatus.UPLOADING);

  // const validateVideo = (file: string) => {
  //   const extension = file.split('.').pop()?.toLowerCase();
  //   if (!extension || !['mp4', 'mov', 'm4v'].includes(extension)) {
  //     throw new Error('Unsupported video format. Please use MP4, MOV, or M4V.');
  //   }
  // };

  // const videoFileToArrayBuffer = (file: File) => {
  //   return new Promise<ArrayBuffer>((resolve, reject) => {
  //     const reader = new FileReader(); // Create a FileReader instance

  //       reader.onload = (e: any) => {
  //           const arrayBuffer = e.target.result; // The ArrayBuffer containing the file data
  //           console.log({arrayBuffer});
  //           resolve(arrayBuffer as ArrayBuffer)
  //           // You can now work with the arrayBuffer, e.g., send it over a network or use it for MediaSource API
  //       };

  //       reader.onerror = (e: any) => {
  //           console.error("FileReader error: ", e.target.error);
  //       };

  //       // Read the file as an ArrayBuffer
  //       reader.readAsArrayBuffer(file);
  //   })
  // }

  const getFileName = (filePath: string): string => {
    const fileName = filePath?.split('/')?.pop() || 'video';
    return fileName.split('.')[0];
  };

  const createVideo = async (filePath: string): Promise<string> => {
    const title = getFileName(filePath);

    const response = await axiosInst.post(
      `https://video.bunnycdn.com/library/${LIBRARY_ID}/videos`,
      {
        title,
        enabledResolutions: '360,480,720',
      },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          AccessKey: API_KEY,
        },
      },
    );

    return response.data.guid;
  };

  const uploadVideo = async (uri: string, file: File, w?: number, h?: number): Promise<Media> => {
    if (FAKE_API) return fakeUploadedMedia(file);
    setIsUploading(true);
    setUploadProgress(0);
    setStatus(UploadStatus.PREPARING);

    try {

      const videoId = await createVideo(file.name)
      // const videoId = ''

      const response = await fetch(uri); // filePath is the blob: or http: url
      const fileBuffer = await response.arrayBuffer();
      // console.log('fileBuffer', fileBuffer)
      // throw Error('ok')
      // const fileBuffer = await videoFileToArrayBuffer(file);

      // Get the file URI properly formatted for the platform
      // const fileUri =
      //   Platform.OS === 'ios' ? file.replace('file://', '') : file;

      // setStatus(UploadStatus.UPLOADING);
      // await uploadFileWithProgress(
      //   `https://video.bunnycdn.com/library/${LIBRARY_ID}/videos/${videoId}`,
      //   file,
      //   {
      //     method: 'PUT',
      //     headers: {
      //       Accept: 'application/json',
      //       AccessKey: API_KEY,
      //       'Content-Type': 'application/octet-stream',
      //     },
      //     onProgress: (progress) => {
      //       const percentCompleted = (progress.loaded / progress.total) * 100;
      //       setUploadProgress(percentCompleted);
      //     },
      //   }
      // )

      // const response = await fetch(uri);
      // const videoBlob = await response.blob(); 

      console.log("Actual Blob Size:", fileBuffer.byteLength);

      // const uploadResponse = await fetch(
      //   `https://video.bunnycdn.com/library/${LIBRARY_ID}/videos/${videoId}`,
      //   {
      //     method: 'PUT',
      //     headers: {
      //       'AccessKey': API_KEY,
      //       'Content-Type': 'application/octet-stream',
      //     },
      //     body: videoBlob, // Send the actual binary object
      //   }
      // );

      // const respo = await uploadResponse.json();

      const respo = await axiosInst.put(`https://video.bunnycdn.com/library/${LIBRARY_ID}/videos/${videoId}`, fileBuffer, {
        headers: {
          AccessKey: API_KEY, // Best practice: backend proxy this
          'Content-Type': 'application/octet-stream',
          Accept: 'application/json',
        },
        onUploadProgress: (p) => console.log('progress',Math.round((p.loaded * 100) / (p.total ?? 0)))
      });

      console.log('respo', respo.data)



      // setStatus(UploadStatus.FETCHING_METADATA);
      const statusResponse = await axiosInst.get(
        `https://video.bunnycdn.com/library/${LIBRARY_ID}/videos/${videoId}`,
        {
          headers: {
            Accept: 'application/json',
            AccessKey: API_KEY,
          },
        },
      );
      

      console.log('statusResponse', statusResponse);

      const width = w || statusResponse.data.width || 16;
      const height = h || statusResponse.data.height || 9;
      const gcd = (a: number, b: number): number => (b ? gcd(b, a % b) : a);
      const divisor = gcd(width, height);
      const aspectRatio = `${width / divisor}:${height / divisor}`;

      const resolutions: ResolutionObject[] = [
        {
          mime_type: 'video/mp4',
          name: 'high',
          aspect_ratio: aspectRatio,
          url: `${CDN_URL}/${videoId}/play_720p.mp4`,
          primary: true,
        },
        {
          mime_type: 'video/mp4',
          name: 'medium',
          aspect_ratio: aspectRatio,
          url: `${CDN_URL}/${videoId}/play_480p.mp4`,
          primary: false,
        },
        {
          mime_type: 'video/mp4',
          name: 'low',
          aspect_ratio: aspectRatio,
          url: `${CDN_URL}/${videoId}/play_360p.mp4`,
          primary: false,
        },
        {
          mime_type: 'image/jpeg',
          name: 'thumbnail',
          aspect_ratio: aspectRatio,
          url: `${CDN_URL}/${videoId}/thumbnail.jpg`,
          primary: false,
        },
      ];

      setStatus(UploadStatus.COMPLETED);
      return {
        resolutions
      };
    } catch (error) {
      setStatus(UploadStatus.FAILED);
      throw error;
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  return {
    uploadVideo,
    isUploadingVideo: isUploading,
    uploadProgress,
    status,
  };
};
